import React, { useRef, useMemo, useState } from "react";
import store from "@/stores/clipEditor/trackState";
import playerStore from "@/stores/clipEditor/player";
import { getGridPixel } from "@/utils/canvasUtil";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { start } from "repl";
import TrackItem from "./TrackItem";
import trackState from "@/stores/clipEditor/trackState";

interface ResizeHandlerProps {
  isActive: boolean;
  lineIndex: number;
  itemIndex: number;
}

const ResizeHandler: React.FC<ResizeHandlerProps> = ({
  isActive,
  lineIndex,
  itemIndex,
}) => {
  const elRef = useRef<HTMLDivElement>(null);
  const handlerLeftRef = useRef<HTMLDivElement>(null);
  const handlerRightRef = useRef<HTMLDivElement>(null);

  // 定位数据缓存
  const [positionLeft, setPositionLeft] = useState(0);
  const [enableMove, setEnableMove] = useState(false);
  const [otherCoords, setOtherCoords] = useState<
    { left: number; right: number; start: number; end: number }[]
  >([]);
  const [fixPosition, setFixPosition] = useState({ left: 0, right: 0 });
  const [moveWidth, setMoveWidth] = useState(0);

  // 手柄可操作的属性配置
  const handlerData = useRef({
    isVideo: false,
    start: 0,
    end: 0,
    offsetR: 0,
    offsetL: 0,
    minStart: 0,
    maxStart: 0,
    minEnd: 0,
    maxEnd: 0,
  });

  // 获取目标轨道项
  const targetTrack = useMemo(() => {
    return store.trackList[lineIndex].list[itemIndex];
  }, [toJS(store.trackList), lineIndex, itemIndex]);

  // 获取吸附辅助线
  const getFixLine = (x: number, distance = 10) => {
    const result = [];
    otherCoords.forEach((coord) => {
      if (Math.abs(coord.left - x) <= distance) {
        result.push({ position: coord.left, frame: coord.start });
      }
      if (Math.abs(coord.right - x) <= distance) {
        result.push({ position: coord.right, frame: coord.end });
      }
    });
    const trackPlayPointX = getGridPixel(
      store.trackScale,
      playerStore.playStartFrame
    );
    if (Math.abs(trackPlayPointX - x) <= distance) {
      result.push({
        position: trackPlayPointX,
        frame: playerStore.playStartFrame,
      });
    }
    return result;
  };

  // 设置吸附
  const adsorption = (
    x: number,
    lines: { position: number; frame: number }[]
  ) => {
    if (lines.length === 0) {
      setFixPosition({ left: 0, right: 0 });
      return;
    }
    const minLeftLine = lines.reduce(
      (r, item) => {
        return Math.abs(item.position - x) < Math.abs(r.position - x)
          ? item
          : r;
      },
      { position: Number.MAX_SAFE_INTEGER, frame: 0 }
    );
    return minLeftLine;
  };

  // 计算帧宽度
  const frameWidth = useMemo(
    () => getGridPixel(store.trackScale, 1),
    [store.trackScale]
  );

  // 初始化限制条件
  const initLimits = (lineData: any[], trackItem: any) => {
    console.log("lineData=====", lineData);
    console.log("trackItem=====", trackItem);
    console.log("itemIndex=====", itemIndex);

    const beforeTrack = itemIndex > 0 ? lineData[itemIndex - 1] : null;
    const afterTrack =
      itemIndex < lineData.length ? lineData[itemIndex + 1] : null;
    console.log("afterTrack=====", afterTrack, "beforeTrack=====", beforeTrack);

    const isVideo = ["video"].includes(trackItem.type);
    const limitData = {
      isVideo,
      start: trackItem.start,
      end: trackItem.end,
      offsetR: trackItem.offsetR,
      offsetL: trackItem.offsetL,
      minStart: beforeTrack ? beforeTrack.end : 0,
      maxStart: trackItem.end - 1,
      minEnd: trackItem.start + 1,
      maxEnd: afterTrack ? afterTrack.start : 30 * 60 * 60, // 最长一小时
    };
    if (isVideo) {
      const rightMaxWidth = trackItem.frameCount - limitData.offsetL;
      const leftMaxWidth = trackItem.frameCount - limitData.offsetR;
      limitData.maxEnd = afterTrack
        ? Math.min(afterTrack.start, limitData.start + rightMaxWidth)
        : Math.min(rightMaxWidth + limitData.start, 30 * 60 * 60);
      limitData.minStart = beforeTrack
        ? Math.max(beforeTrack.end, limitData.end - leftMaxWidth)
        : Math.max(limitData.end - leftMaxWidth, 0);
    }
    Object.assign(handlerData.current, limitData);
  };

  // 设置轨道帧数据
  const setTrackFrameData = (frameCount: number, handleType: string) => {
    const {
      isVideo,
      start: originStart,
      end: originEnd,
      offsetR,
      offsetL,
      minStart,
      maxStart,
      minEnd,
      maxEnd,
    } = handlerData.current;
    const originWidth = originEnd - originStart;
    const leftMaxWidth = offsetL + originWidth;
    const rightMaxWidth = offsetR + originWidth;
    // console.log("originWidth", originWidth);
    // console.log("leftMaxWidth", leftMaxWidth);
    // console.log("rightMaxWidth", rightMaxWidth);

    if (handleType === "left") {
      let newStart = originStart + frameCount;

      if (targetTrack.type !== "video") {
        if (newStart > maxStart) newStart = maxStart;
        if (newStart < minStart) newStart = minStart;
      } else {
        console.log("newStart", newStart, maxStart);
        if (newStart >= maxStart) {
          // newStart = minStart;
          return;
        }
      }

      let diffStart = newStart - originStart;
      console.log("isVideo", isVideo);

      if (isVideo) {
        if (originEnd - newStart > leftMaxWidth) {
          newStart = originEnd - leftMaxWidth;
          diffStart = newStart - originStart;
        }

        store.updateTrack(lineIndex, itemIndex, {
          offsetL: Math.max(offsetL + diffStart, 0),
          start: 0,
          end: originEnd - newStart,
        });
      } else {
        console.log(
          "nweStart=========",
          newStart,
          originEnd,
          originEnd - newStart
        );

        store.updateTrack(lineIndex, itemIndex, {
          frameCount: originEnd - newStart,
          start: newStart,
        });
      }

      // if (!trackState.isClip) {
      store.adjustVideoTrack();
      // }
    } else {
      let newEnd = originEnd + frameCount;
      // if (targetTrack.type !== "video") {
      if (newEnd > maxEnd) newEnd = maxEnd;
      if (newEnd < minEnd) newEnd = minEnd;
      // } else {
      //   if (newEnd < minEnd) {
      //     return;
      //   }
      // }

      if (isVideo) {
        if (newEnd - originStart > rightMaxWidth) {
          newEnd = originStart + rightMaxWidth;
        }
        const diffEnd = newEnd - originEnd;
        store.updateTrack(lineIndex, itemIndex, {
          offsetR: Math.max(offsetR - diffEnd, 0),
        });
      } else {
        // store.trackList[lineIndex].groups[itemIndex].frameCount =
        //   newEnd - originStart;
        store.updateTrack(lineIndex, itemIndex, {
          frameCount: newEnd - originStart,
        });
      }
      // store.trackList[lineIndex].groups[itemIndex].end = newEnd;
      store.updateTrack(lineIndex, itemIndex, {
        end: newEnd,
      });

      // const videoGroups = store.trackList[lineIndex].groups;

      // if (!trackState.isClip) {
      store.adjustVideoTrack();
      // }
    }
  };

  // 处理鼠标按下事件
  const mouseDownHandler = (event: React.MouseEvent, type: string) => {
    event.preventDefault();
    event.stopPropagation();

    const newOtherCoords = [];
    for (let i = 0; i < store.trackList.length; i++) {
      for (let j = 0; j < store.trackList[i].list.length; j++) {
        if (i !== lineIndex || j !== itemIndex) {
          const item = store.trackList[i].list[j];
          newOtherCoords.push({
            start: item.start,
            end: item.end,
            left: getGridPixel(store.trackScale, item.start),
            right: getGridPixel(store.trackScale, item.end),
          });
        }
      }
    }
    setOtherCoords(newOtherCoords);
    playerStore.setPause(true);
    setPositionLeft(event.pageX);
    setEnableMove(true);
    initLimits(store.trackList[lineIndex]?.list || [], targetTrack);

    const trackItem = elRef.current?.closest(".trackItem");
    const position =
      type === "left"
        ? (trackItem as any)?.offsetLeft || 0
        : ((trackItem as any)?.offsetLeft || 0) +
          ((trackItem as any)?.offsetWidth || 0);

    const onMouseMove = (documentEvent: MouseEvent) => {
      // if (!enableMove) return;
      const { pageX } = documentEvent;
      // 获取当前鼠标位置
      const w = event.pageX - pageX;
      console.log("moveWidth", w, frameWidth);

      setMoveWidth(w);

      const lines = getFixLine(position - w);
      store.setDragData({ fixLines: [lines] });

      const result = adsorption(position - w, lines);

      const frameCount = result?.frame
        ? type === "left"
          ? result.frame - targetTrack.start
          : result.frame - targetTrack.end
        : -Math.round(w / frameWidth);
      console.log("frameCount", result, frameCount);

      setTrackFrameData(frameCount, type);
    };

    const onMouseUp = () => {
      // 拖拽复位
      // const diff = store.trackList[lineIndex]?.groups[itemIndex]?.start;
      // const originEnd = store.trackList[lineIndex]?.groups[itemIndex]?.end;

      // store.updateTrack(lineIndex, itemIndex, {
      //   start: 0,
      //   end: originEnd - diff,
      // });
      setEnableMove(false);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <div
      className={`track-handler`}
      ref={elRef}
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        border: "1px solid #165DFF",
        display: isActive ? "block" : "none",
        userSelect: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          zIndex: 5,
          left: "-4px",
          top: -1,
          bottom: -1,
          width: "6px",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          justifyContent: "center",
          backgroundColor: "#165DFF",
          borderRadius: "3px 0 0 3px",
          cursor: "col-resize",
        }}
        className="cursor-c-resize"
        ref={handlerLeftRef}
        onMouseDown={(e) => mouseDownHandler(e, "left")}
      >
        <span style={{ color: "#FFF", fontSize: 20 }}>|</span>
      </div>

      <div
        style={{
          position: "absolute",
          zIndex: 5,
          right: "-4px",
          top: -1,
          bottom: -1,
          width: "6px",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          justifyContent: "center",
          backgroundColor: "#165DFF",
          borderRadius: "0 3px 3px 0",
          cursor: "col-resize",
        }}
        className="cursor-c-resize"
        ref={handlerRightRef}
        onMouseDown={(e) => mouseDownHandler(e, "right")}
      >
        <span style={{ color: "#fff", fontSize: 20 }}>|</span>
      </div>
    </div>
  );
};

export default observer(ResizeHandler);
